export const CONTACT_TYPES = /** @type {const} */ ({
  USER: 'user',
  CONTACT: 'contact',
});

export const TEAM_GROUPS = /** @type {const} */ ({
  STAFF: 'staff',
  CONTACTS: 'contacts',
  TRAINEES: 'trainees',
});

/** @typedef {(typeof TEAM_GROUPS)[keyof typeof TEAM_GROUPS]} TeamGroup */

/**
 * Team groups the add/remove-member mutations may write — staff/contacts only.
 * Trainees are excluded on purpose: they're displayed from the separate
 * `useTrainees` query (`rotationsKeys.trainees`), so writing a trainee through
 * those mutations would patch `detail.team.trainees` but leave the displayed
 * list stale. To support trainee editing, drop the Exclude here AND
 * patch/invalidate `rotationsKeys.trainees(rotationId)` in the mutation hooks.
 *
 * @typedef {Exclude<TeamGroup, typeof TEAM_GROUPS.TRAINEES>} EditableTeamGroup
 */
